module.exports = __webpack_public_path__ + "assets/img/ION Orchard.346e587f.jpg";